import { render, staticRenderFns } from "./admin-product-view.vue?vue&type=template&id=53dda8e8&scoped=true"
import script from "./admin-product-view.vue?vue&type=script&lang=js"
export * from "./admin-product-view.vue?vue&type=script&lang=js"
import style0 from "./admin-product-view.vue?vue&type=style&index=0&id=53dda8e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dda8e8",
  null
  
)

export default component.exports